export default {
	actions: {
		// todo поебень влиять на дом из стора плохо оч плохо
		sendNotification() {
			// console.log(payload)
			// var notifyElement = $("<div />").addClass('alert alert-' + payload.type).html(payload.quote);
			// $('.notify').prepend(notifyElement);
			// setTimeout(function (ele) {
			// 	ele.remove();
			// }, 8000, notifyElement);
		},
		goToCashHome({rootState}) {
			if(rootState.newOrder.order.status != 'inprogress') {
				window.open("/", "_self")
			}
		}
	},
	mutations: {
		updateDisplayNone(state, displayNone) {
			state.displayNone = displayNone
		},
	},
	state: {
		displayNone: false,
	},
	getters: {
		displayNone(state) {
			return state.displayNone
		},
	}
}
